'use strict';

var CommonsConfig = function CommonsConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $stateProvider.state('app', {
    "abstract": true,
    template: require('../templates/application.html'),
    controller: 'CommonsConfigController'
  });
  $urlRouterProvider.otherwise('/workflow/dashboard');
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: true
  });
};
CommonsConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
module.exports = CommonsConfig;